import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./campaigns.module.css";
import Loader from "../../../components/Loader";
import Footer from "../../../components/Footer";
import { ArrowLeft, Home, X } from "react-feather";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";
import { TableLoaderSmall } from "../../../components/LoaderC";
import axios from "axios";
import { useHistory } from "react-router-dom";
import SendContact from "./components/SendContact";
import CampaignFilter from "./components/CampaignFilter";
import CampaignCard from "./components/CampaignCard";
import { toast } from 'react-smart-toaster';

const Campaigns = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [filterData, setFilterData] = useState({ searchKey: "" });
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(8);
  const history = useHistory();
  const [selectedItem, setSelectedItem] = useState(null);
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [publishModalOpen, setPublishModalOpen] = useState(false);

  useEffect(() => {
    const getEmailTemplateList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    }

    getEmailTemplateList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (allData.length > 0) {
      let filteredDataTemp = allData;

      if (filterData.searchKey !== "") {
        let inputVal = filterData.searchKey;
        inputVal = inputVal.toLowerCase();
        filteredDataTemp = filteredDataTemp.filter((item) => {
          return item.title.toLowerCase().includes(inputVal);
        });
      }

      if (filterData.type !== "" && filterData.type !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => i.type === filterData.type);
      }

      setFilteredData(filteredDataTemp);
    }
  }, [allData, filterData]);

  const navigateTo = (routeName) => {
    history.push(routeName);
  }

  const confirmDelete = async () => {
    setDeleteModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_USER_API_URL + 'v1/campaign/email-templates/' + selectedItem?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setLoading(false);

      setAllData(prev => {
        return prev?.filter(i => i?.id !== selectedItem?.id);
      });
      setSelectedItem(null);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const changeStatusConfirm = async (data) => {
    setLoading(true);
    setArchiveModalOpen(false);
    setPublishModalOpen(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.put(process.env.REACT_APP_USER_API_URL + 'v1/campaign/email-templates/' + selectedItem?.id, { is_archived: data }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg("Email campaign updated successfully.");
      setSnackbarOpen(true);

      setAllData(prev => {
        return prev?.map((item) => {
          if (item.id === selectedItem?.id) {
            return { ...item, is_archived: data };
          }
          return item;
        })
      });

      setSelectedItem(null);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const copyCampign = async (id) => {
    setLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.post(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates/copy/" + id, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response?.data?.message);
      setSnackbarOpen(true);

      setAllData(prev => {
        return prev.concat([response?.data?.data]);
      });
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    <Helmet title="Email Template" />

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Manage Campaign</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Champaign</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Manage Campaign</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          {contentLoading && (<div className="Loader TableLoader">
            <TableLoaderSmall />
          </div>)}

          {!contentLoading && (<div className="control-pane">
            <div className={`${styles.Row}`}>

              <CampaignFilter setFilterData={setFilterData.bind(this)} />

              <div className={`${styles.NotesRow}`}>
                {filteredData.length > 0 &&
                  filteredData.map((et, index) => {
                    return <CampaignCard item={et} navigateTo={navigateTo.bind(this)} setSendModalOpen={setSendModalOpen.bind(this)} setSelectedItem={setSelectedItem.bind(this)} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setPublishModalOpen={setPublishModalOpen.bind(this)} setArchiveModalOpen={setArchiveModalOpen.bind(this)} copyCampign={copyCampign.bind(this)} />
                  })}
              </div>

              {filteredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                <TablePagination
                  count={filteredData.length}
                  color="primary"
                  page={page}
                  rowsPerPage={perPage}
                  onPageChange={(e, v) => setPage(v)}
                  rowsPerPageOptions={[
                    { label: "4", value: 4 },
                    { label: "8", value: 8 },
                    { label: "16", value: 16 },
                    { label: "All", value: -1 },
                  ]}
                  onRowsPerPageChange={(e) => {
                    setPage(0);
                    setPerPage(e.target.value);
                  }}
                  labelRowsPerPage={"Campaigns per Page:"}
                />
              </div>)}

              {filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                <div className={`${styles.NoDataIMG}`}>
                  <img src="/static/img/no-prospect.png" alt="No Data" />
                </div>
                <p className={`${styles.NoDataText}`}>Let's get started!</p>
                <p className={`${styles.NoDataTextSub}`}>You don't have any groups saved.</p>
              </div>)}
            </div>
          </div>)}
        </div>
      </div>
    </div>

    <Dialog
      open={deleteModalOpen}
      onClose={(e) => setDeleteModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Would you like to delete this campaign?
        <button onClick={(e) => setDeleteModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The campaign information will be removed immediately. You can't undo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmDelete(false)} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={archiveModalOpen}
      onClose={(e) => setArchiveModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to archive email campaign?<button onClick={(e) => setArchiveModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The lemail campaign will be archived immediately. You can publish it at any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setArchiveModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button className="SubmitPopupBU" onClick={(e) => changeStatusConfirm(1)}>Archive</button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={publishModalOpen}
      onClose={(e) => setPublishModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to publish email campaign?<button onClick={(e) => setPublishModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The email campaign will be published immediately. You can unpublish it at any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setPublishModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button className="SubmitPopupBU" onClick={(e) => changeStatusConfirm(0)}>Publish</button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={sendModalOpen}
      onClose={(e) => { setSendModalOpen(false) }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => { setSendModalOpen(false) }}><ArrowLeft /></button>
        Send Email
        <button onClick={(e) => { setSendModalOpen(false) }}><X /></button>
      </DialogTitle>
      <DialogContent>
        <SendContact setAddModalOpen={setSendModalOpen.bind(this)} campaign={selectedItem} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setLoading={setLoading.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>);
};

export default withAuthenticationRequired(Campaigns, {
  onRedirecting: () => <Loader />,
});